// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BasePublicFactory instead of class inheritance

import { createBasePublic, type IBasePublic } from "../BasePublicFactory";
import type { IIncidentReportRequest, IIncidentReportResponse } from "./IncidentReport";

interface IncidentReportInstance {
	reportIncident(data: IIncidentReportRequest): Promise<IIncidentReportResponse>;
}

// Module-level singleton instance
let instance: IncidentReportInstance | null = null;
let basePublicInstance: IBasePublic | null = null;

function createIncidentReport(): IncidentReportInstance {
	if (!basePublicInstance) {
		basePublicInstance = createBasePublic();
	}

	const basePublic = basePublicInstance;

	return {
		reportIncident: async (data: IIncidentReportRequest): Promise<IIncidentReportResponse> => {
			const url = new URL(`${basePublic.namespaceUrl}/incident-report`);
			try {
				return await basePublic.postRequest<IIncidentReportResponse>(url, data);
			} catch (error) {
				basePublic.onError(error);
				return Promise.reject(error);
			}
		},
	};
}

export function getIncidentReportInstance(): IncidentReportInstance {
	if (!instance) {
		instance = createIncidentReport();
	}
	return instance;
}
